/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'lab': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M26 15h-6v-2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2zm7.425 20.244c-.276.481-.795.756-1.425.756H14c-.63 0-1.149-.275-1.425-.756s-.252-1.067.065-1.612l5.992-10.271c.189-.325.368-.986.368-1.361v-4h-.5a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5h9c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5H27v4c0 .375.179 1.036.368 1.36l5.992 10.271c.317.546.341 1.133.065 1.613zM27.759 28l-2.119-3.632C25.275 23.742 25 22.725 25 22v-4h-4v4c0 .725-.275 1.742-.64 2.368L18.241 28h9.518z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/lab.js